import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { ISceneEditorState } from '.';

const sceneEditor = (state: RootState) => state.sceneEditor;

export const selectSceneEditor = createSelector([sceneEditor], (sceneEditor: ISceneEditorState) => {
  return sceneEditor;
});
